import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgMark = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M22.304 7.426h-6.72V4.459a.84.84 0 0 0-.84-.84H4.034V2.57a.21.21 0 0 0-.21-.21h-1.47a.21.21 0 0 0-.21.21v20.58c0 .116.095.21.21.21h1.47a.21.21 0 0 0 .21-.21v-6.93h6.51v2.967c0 .464.376.84.84.84h10.92a.84.84 0 0 0 .84-.84V8.266a.84.84 0 0 0-.84-.84Zm-18.27 6.903V5.51h9.66v8.82h-9.66Zm17.22 3.807h-8.82v-1.917h2.94a.21.21 0 0 0 .21-.21V9.316h5.67v8.82Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgMark)
const Memo = memo(ForwardRef)
export default Memo
